interface Props {
  color: string | "#D0DEE6",
}
const LineHeight = (props: Props) => {
  return (
  <svg width="28" height="19" viewBox="0 0 28 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.83398 11.6667H26.834M8.83398 6.33333H26.834M8.83398 1H26.834M8.83398 17H26.834M3.66699 17.5V1M3.66699 17.5L1.66699 15.5M3.66699 17.5L5.66699 15.5M3.66699 1L1.66699 3M3.66699 1L5.66699 3" stroke={props.color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
  )
}
export default LineHeight;
